import { render, staticRenderFns } from "./ActionPost.vue?vue&type=template&id=5dcd3f43"
import script from "./ActionPost.vue?vue&type=script&lang=js"
export * from "./ActionPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports